import { SetData } from './SetData';
import { VerifyData } from './VerifyData';

export const ImportCompanyData = {
  SetData,
  VerifyData,
};
